import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AddressSearch, Environment } from '@nx-ng/types';
import { ENVIRONMENT } from '@modules/core';
import { AddressesStoreActions } from '../actions';
import { IAddressesFeatureState } from '../reducers';
import { AddressesStoreSelectors } from '../selectors';
import { debounce } from 'lodash-es';

const DEBOUNCE_TIME = 1000;

@Injectable({
  providedIn: 'root',
})
export class AddressesStoreFacade {
  constructor(
    private readonly store: Store<IAddressesFeatureState>,
    @Inject(ENVIRONMENT) private env: Environment
  ) {
    this.search = debounce(this.search, DEBOUNCE_TIME);
  }

  searchIsLoading$ = this.store.select(
    AddressesStoreSelectors.selectSearchLoadingStatus
  );
  searchResult$ = this.store.select(AddressesStoreSelectors.selectSearchResult);
  searchSession$ = this.store.select(
    AddressesStoreSelectors.selectSearchSession
  );
  retrieveIsLoading$ = this.store.select(
    AddressesStoreSelectors.selectRetrieveLoadingStatus
  );
  retrievedAddress$ = this.store.select(
    AddressesStoreSelectors.selectRetrievedAddress
  );

  handleOperation(event: AddressSearch) {
    switch (event?.operation) {
      case 'search':
        this.search(event.fragment ?? '', event.requester);
        break;
      case 'drilldown':
        if (event.id) {
          this.drillDown(event.id, event.requester);
        }
        break;
      case 'retrieve':
        if (event.id) {
          this.retrieve(event?.id, event.requester);
        }
        break;
    }
  }

  search(searchText: string, requester: string) {
    if (
      searchText &&
      searchText.length >= this.env.nxApi.minAddressSearchChars
    ) {
      this.store.dispatch(
        AddressesStoreActions.addressAPI_search({
          searchText,
          requester,
        })
      );
    }
  }

  drillDown(id: string, requester: string) {
    this.store.dispatch(
      AddressesStoreActions.addressAPI_drillDown({ id, requester })
    );
  }

  retrieve(id: string, requester: string) {
    this.store.dispatch(
      AddressesStoreActions.addressAPI_retrieve({ id, requester })
    );
  }
}
